// 'use strict';

var util = require('./property-util');
var graphUtil = require('./graph-util');

module.exports = {
    parseSynchronizationState: function (data, callback) {
        var empty = {"empty": true};

        var ads;
        var news;
        var newspaper;
        var weather;

        var media = new Map();
        media.set('ads', empty);
        media.set('news', empty);
        media.set('newspaper', empty);
        media.set('weather', empty);

        var lastSyncDate = new Date();
        data.forEach(function (content) {
            switch (content.content) {
                case "ads":
                    ads = createContentEntity(content, "Advertisements");
                    media.set("ads", ads);
                    break;
                case "news":
                    news = createContentEntity(content, "News");
                    media.set("news", news);
                    break;
                case "newspaper":
                    newspaper = createContentEntity(content, "Newspaper");
                    media.set("newspaper", newspaper);
                    break;
                case "weather":
                    weather = createContentEntity(content, "Weather");
                    media.set("weather", weather);
                    break;
            }
            lastSyncDate = content.lastSynchronized;
        });

        var content = {};
        media.forEach(function (value, key, map) {
            var object = value;
            //we did not receive this entry from the server, this means everything was successfully synced.
            if (util.isDefined(value['empty'])) {
                object = {
                    'content': key,
                    'notSynced': 0,
                    'lastSyncDate': lastSyncDate,
                    'state': 'success',
                    'traincount': 0
                }
            }
            content[key] = object;
        });
        callback(content);
    },

    createLoginChart: function (data, axesMap, graphMap, dataMap, functionCallback) {
        var newData = [];
        data.forEach(function (entry) {
            newData.push({'timestamp': new Date(entry.timestamp), 'users': entry.value});
        });

        if (!axesMap.has('loginAxis')) {
            var offset = calculateOffset(getMapValueAsList(axesMap), 'position', 'right', 80);

            var axis = createNewValueAxis('loginAxis', 'Black', 'right', offset, ' users');
            var graph = createNewGraph('loginAxis', 'Blue', 'User Axis', 'users', ' users');

            graphMap.set('loginAxis', graph);
            axesMap.set('loginAxis', axis);
        }

        dataMap.set('users', newData);
        functionCallback(dataMap, axesMap, graphMap);
    },

    createConsumptionChart: function (data, axesMap, graphMap, dataMap, functionCallback) {
        var newData = [];
        data.forEach(function (entry) {
            var value = entry.value / (1000 * 1000 * 1000);
            value = Math.round(value);
            newData.push({'timestamp': new Date(entry.timestamp), 'consumption': value});
        });

        if (!axesMap.has('consumptionAxis')) {
            offset = calculateOffset(getMapValueAsList(axesMap), 'position', 'left', 75);

            var axis = createNewValueAxis('consumptionAxis', 'Black', 'left', offset, ' GB');
            var graph = createNewGraph('consumptionAxis', 'Red', 'User consumption', 'consumption', ' GB');

            graphMap.set('user-graph', graph);
            axesMap.set('consumptionAxis', axis);
        }

        dataMap.set('consumption', newData);
        functionCallback(dataMap, axesMap, graphMap);
    },

    createVuNgChart: function (data, axesMap, graphMap, dataMap, functionCallback) {
        var newData = [];
        data.forEach(function (entry) {
            newData.push({'timestamp': new Date(entry.timestamp), 'vung': entry.value});
        });

        if (!axesMap.has('vuNgAxis')) {
            var offset = calculateOffset(getMapValueAsList(axesMap), 'position', 'left', 60);
            var axis = createNewValueAxis('vuNgAxis', 'Black', 'left', offset, '%');
            var graph = createNewGraph('vuNgAxis', 'Green', 'VU-NG', 'vung', '%');

            axesMap.set('vuNgAxis', axis);
            graphMap.set('vungGraph', graph);
        }

        dataMap.set('vung', newData);
        functionCallback(dataMap, axesMap, graphMap);
    },

    createSlaChart: function (data, axesMap, graphMap, dataMap, functionCallback) {
        var sqiMap = new Map();

        if (!axesMap.has('sqiPercentAxis')) {
            var offset = calculateOffset(getMapValueAsList(axesMap), 'position', 'left', 60);

            var axisPercent = createNewValueAxis('sqiPercentAxis', 'Black', 'left', offset, '%');
            offset = offset + 60;
            var axisSecond = createNewValueAxis('sqiSecondsAxis', 'Black', 'left', offset, 's');

            axesMap.set('sqiPercentAxis', axisPercent);
            axesMap.set('sqiSecondsAxis', axisSecond);
        }

        data.forEach(function (sqiValue) {
            var list = sqiMap.get(sqiValue.sqiId);
            if (!util.isDefined(list)) {
                list = [];
                sqiMap.set(sqiValue.sqiId, list);
            }

            list.push({
                'timestamp': new Date(sqiValue.timestamp),
                'value': sqiValue.value
            });
        });

        sqiMap.forEach(function (values, key, map) {
            values.forEach(function (value) {
                value['sqi_' + key] = value.value;
                delete value.value;
            })
        });

        sqiMap.forEach(function (values, key, map) {
            var graph = undefined;
            switch (key) {
                case 101:
                    graphMap.set('sla11Graph', createNewGraph('sqiPercentAxis', 'Grey', 'SLA 1.1', 'sqi_101', '%'))
                    break;
                case 102:
                    graphMap.set('sla12Graph', createNewGraph('sqiSecondsAxis', 'Black', 'SLA 1.2', 'sqi_102', 's'))
                    break;
                case 103:
                    graphMap.set('sla2Graph', createNewGraph('sqiPercentAxis', 'Darkblue', 'SLA 2.0', 'sqi_103', '%'))
                    break;
            }
            dataMap.set(key, values);
        });

        functionCallback(dataMap, axesMap, graphMap);
    },

    createContentEntity: function (content, mediaType) {
        var media = {};
        media.content = mediaType;
        media.notSynced = content.amountNotSynchronized;
        media.lastSyncDate = content.lastSynchronized;
        media.state = 'danger';
        if (content.traincount === 0) {
            media.state = 'success';
        } else {
            if (content.traincount < 19) {
                media.state = 'warn';
            }
        }
        media.traincount = content.traincount;
        return media;
    },

    createSqiGauge: function (sqiValue, sqiToDivLinker) {
        if (util.isDefined(sqiValue)) {
            var divId = sqiToDivLinker(sqiValue);
            module.exports.emptyDiv(divId);
            graphUtil.createGauge(sqiValue.average, sqiValue.label, divId, sqiValue.unit, sqiValue.inverseValue, sqiValue.min, sqiValue.max);
        }
    },

    emptyDiv: function (divid) {
        var x = document.getElementById(divid);
        if (util.isDefined(x)) {
            x.innerHTML = '';
        }
    }
};




